// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TicketVariables[data-v-7dcca0b8]{display:flex;flex-direction:column;gap:.5rem}.TicketVariables .variables-container[data-v-7dcca0b8]{min-width:200px;border:1px solid var(--border-color)}.TicketVariables .variables-container>div[data-v-7dcca0b8]{cursor:pointer;padding:.25rem .5rem;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.TicketVariables .variables-container>div[data-v-7dcca0b8]:hover{background-color:rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
